import script from "./otherKnowledge.vue?vue&type=script&setup=true&lang=js"
export * from "./otherKnowledge.vue?vue&type=script&setup=true&lang=js"

import "./otherKnowledge.vue?vue&type=style&index=0&id=455f65ce&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-455f65ce"]])

export default __exports__